import { render } from "./PrimitiveChannel.vue?vue&type=template&id=320e5afa"
import script from "./PrimitiveChannel.vue?vue&type=script&lang=js"
export * from "./PrimitiveChannel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\ga38som\\IdeaProjects\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__